import {Graphics} from 'pixi.js';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {DestroyOptions, Store} from '@gongxigames/framework/core';

export type FullScreenFaderOptions = {
    alpha?: number;
    color?: number;
    name?: string;
    screenParameters?: ScreenParameters;
};

export class FullScreenFader extends Graphics {
    protected offEffect?: () => void;
    constructor(
        public readonly options: FullScreenFaderOptions = {}
    ) {
        super();

        const color = options.color || 0;

        this.beginFill(color)
            .drawRect(0, 0, 1, 1)
            .endFill();

        this.alpha = options.alpha ?? 1;
        this.name = options.name || 'FullScreenFader';

        if (options.screenParameters) {
            this.resize(options.screenParameters);
        }

        if (slotStore.isV2SafeZoneSystemActive.value) {
            this.offEffect = Store.effect(() => this.resizeV2());
        }
    }

    protected resizeV2(): void {
        const safeZone = slotStore.stage_safeZoneState_ui.value;
        const screenBounds = safeZone.calcInSafeFader();

        this.height = screenBounds.height * 2;
        this.width = screenBounds.width * 2;
    }

    public resize(screenParameters: ScreenParameters): this {
        if (!slotStore.isV2SafeZoneSystemActive.value) {
            const x = Math.ceil(Math.ceil(screenParameters.x) / screenParameters.scale);
            const y = Math.ceil(Math.ceil(screenParameters.y) / screenParameters.scale);

            this.width = screenParameters.width + x * 2;
            this.height = screenParameters.height + y * 2;

            this.position.set(-x, -y);
        }

        return this;
    }

    public destroy(options?: DestroyOptions): void {
        this.offEffect?.();
        super.destroy(options);
    }
}
